import * as Yup from 'yup';

import { PayoutStatus } from 'types';

export const decisionOptions = [
  { label: 'Approve', value: PayoutStatus.Approved },
  { label: 'Partial approve', value: PayoutStatus.PartialApproved },
  { label: 'Reject', value: PayoutStatus.NotApproved },
];

export interface EditDecisionValues {
  amount: string;
  reasonReject: string;
  status: PayoutStatus;
}

export const getInitialValues = ({
  amount,
  status,
  reasonReject,
}: {
  amount: number;
  status: PayoutStatus;
  reasonReject?: string;
}): EditDecisionValues => ({
  status,
  reasonReject: reasonReject ?? '',
  amount: status === PayoutStatus.PartialApproved ? String(amount) : '',
});

// $1,234.50 (kept local: utils/helpers pulls in the router)
const usd = (value: number) =>
  Number(value).toLocaleString('en-US', {
    currency: 'USD',
    style: 'currency',
  });

export const getValidationSchema = (requestedAmount: number) =>
  Yup.object().shape({
    status: Yup.string().required(),
    reasonReject: Yup.string().when('status', {
      is: PayoutStatus.NotApproved,
      otherwise: (schema) => schema.notRequired(),
      then: (schema) => schema.trim().required('Add a rejection reason'),
    }),
    amount: Yup.number()
      // An empty field is no amount (only a partial needs one).
      .transform((value, original) => (original === '' ? undefined : value))
      .when('status', {
        is: PayoutStatus.PartialApproved,
        otherwise: (schema) => schema.notRequired(),
        then: (schema) =>
          schema
            .required('Enter the approved amount')
            .positive('Must be more than $0')
            // The full amount is an Approve, not a partial.
            .lessThan(
              Number(requestedAmount),
              `Must be less than the requested amount (${usd(requestedAmount)})`
            ),
      }),
  });
